import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    supportedLngs: ['en', 'fr', 'es', 'zh', 'ar'],
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },

    react: {
      useSuspense: true,
    },
  });

// Apply html lang + dir (RTL for Arabic) on initial load and whenever language changes
const applyHtmlLangDir = (lng) => {
  const resolved = (lng || 'en').split('-')[0];
  if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.lang = resolved;
    document.documentElement.dir = resolved === 'ar' ? 'rtl' : 'ltr';
  }
};

i18n.on('languageChanged', applyHtmlLangDir);
i18n.on('initialized', () => applyHtmlLangDir(i18n.language));
// In case i18n was already initialized before this listener attached
if (i18n.isInitialized) {
  applyHtmlLangDir(i18n.language);
}

export default i18n;
